"use client"

import Image from "next/image"
import { useTranslations } from "next-intl"
import type { HTMLAttributes } from "react"
import { Separator } from "@/components/ui/separator"
import { cn } from "@/utils/cn"

const AVATARS = [
  { src: "https://testingbot.com/free-online-tools/random-avatar/128?u=1", alt: "Student 1" },
  { src: "https://testingbot.com/free-online-tools/random-avatar/128?u=2", alt: "Student 2" },
  { src: "https://testingbot.com/free-online-tools/random-avatar/128?u=3", alt: "Student 3" },
  { src: "https://testingbot.com/free-online-tools/random-avatar/128?u=4", alt: "Student 4" },
  { src: "https://testingbot.com/free-online-tools/random-avatar/128?u=5", alt: "Student 5" },
]

interface TestimonialAvatarsProps extends HTMLAttributes<HTMLDivElement> {}

export function TestimonialAvatars({ className, ...props }: TestimonialAvatarsProps) {
  const t = useTranslations("Pricing")

  return (
    <div
      className={cn(
        "mx-auto flex w-fit max-w-full items-center overflow-hidden rounded-full border bg-background p-1 shadow-xs",
        className,
      )}
      {...props}
    >
      <AvatarsStack />
      <Separator orientation="vertical" className="mx-2 h-5" />
      <div className="mr-2 truncate font-medium text-sm">{t("accounts-tracked")}</div>
    </div>
  )
}

function AvatarsStack() {
  return (
    <div className="-space-x-3 flex">
      {AVATARS.map((avatar) => (
        <div
          key={avatar.alt}
          className="size-[28px] overflow-hidden rounded-full border-[2.5px] border-background"
        >
          <Image
            src={avatar.src}
            alt={avatar.alt}
            width={28}
            height={28}
            quality={75}
            className="h-full w-full select-none object-cover"
            priority
          />
        </div>
      ))}
    </div>
  )
}
